import { UpdateEntryDateResponse, BaseReducerState } from '../../../services'
import { ActionTypes } from '../actions'

export type UpdateEntryDateState = BaseReducerState & {
  data: boolean
}

const initialUpdateEntryDateState: UpdateEntryDateState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const updateEntryDate = (
  state: UpdateEntryDateState = initialUpdateEntryDateState,
  action: { type: string; res: any }
): UpdateEntryDateState => {
  switch (action.type) {
    case `${ActionTypes.UPDATE_ENTRY_DATE}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.UPDATE_ENTRY_DATE}_SUCCESS`: {
      const { success, data, message } = <UpdateEntryDateResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.UPDATE_ENTRY_DATE}_FAILURE`: {
      const res = <UpdateEntryDateResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }
    }

    case `${ActionTypes.UPDATE_ENTRY_DATE}_RESET`:
      return {
        ...initialUpdateEntryDateState,
      }
  }
  return state
}
